import * as THREE from 'three';

export default class ProductRepresentation {
    geometry: THREE.Object3D;
    
    constructor(geometry: THREE.Object3D) {
        this.geometry = geometry;
    }

     private getBaseQuaternion(): void {
            if (!this.geometry.parent) return;
            
            this.geometry.updateMatrixWorld(true);
            const parentWorldQuat = new THREE.Quaternion();
            this.geometry.parent.getWorldQuaternion(parentWorldQuat);
            
            
            const inverseParentRotation = parentWorldQuat.clone().invert();
            this.geometry.setRotationFromQuaternion(inverseParentRotation);
            this.geometry.matrix.decompose(this.geometry.position, this.geometry.quaternion, this.geometry.scale);
        }
    
    dispose() {
        // Traverse and dispose GPU geometry buffers.
        // Materials are intentionally NOT disposed here because they come from shared
        // MaterialPair records and may still be in use by sibling representations.
        this.geometry.traverse((child) => {
            if (child instanceof THREE.Mesh || child instanceof THREE.Line) {
                child.geometry.dispose();
            }
        });
        if (this.geometry.parent) {
            this.geometry.parent.remove(this.geometry);
        }
        this.geometry.clear();
    }
}
